import { render } from "./customerInquiry.vue?vue&type=template&id=515787f6&scoped=true"
import script from "./customerInquiry.vue?vue&type=script&lang=js"
export * from "./customerInquiry.vue?vue&type=script&lang=js"

import "./customerInquiry.vue?vue&type=style&index=0&id=515787f6&lang=less&scoped=true"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515787f6"]])

export default __exports__